import React, { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import ReactDOM from 'react-dom/client'
import 'intl-pluralrules'
import 'crypto-browserify'
import 'stream-browserify'
import 'vm-browserify'
import 'buffer'
import 'process/browser'
import './styles/index.scss'
import AppRouter from './AppRouter'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import { Spinner } from '@digicert/dcone-common-ui'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Suspense fallback={<Spinner />}>
      <I18nextProvider i18n={i18n}>
        <RouterProvider router={AppRouter} fallbackElement={<Spinner />}/>
      </I18nextProvider>
    </Suspense>
  </React.StrictMode>
);
